// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FormatQuoteIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="FormatQuoteIcon" ref={forwardedRef} {...props}>
      <path d="M8.997 11c0 .269-.06.809-.247 1L6 15c-.315.32-1-.049-1-.502v-3H4c-.553 0-1-.438-1-1v-5c0-.562.447-1 1-1h3.998c.552 0 1 .438 1 1zm-2.792 1.75 1.294-1.5V5.998h-3l.001 4h1.705z" />
      <path d="M16.998 11c0 .269-.061.809-.248 1L14 15c-.315.32-1-.049-1-.502v-3h-1c-.553 0-1-.438-1-1v-5c0-.562.447-1 1-1h3.998c.552 0 1 .438 1 1zm-2.793 1.75 1.294-1.5V5.998h-3l.001 4h1.705z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const FormatQuoteIcon = /* @__PURE__ */ Object.assign(
  FormatQuoteIconComponent,
  { displayName: 'FormatQuoteIcon' },
);
